import BackArrow from '@/app/components/questionnaireV2/icons/back-arrow';

interface StickyFooterBarProps {
  variant: 'light' | 'dark';
  onBack?: () => void;
  isBackDisabled?: boolean;
  topContent?: React.ReactNode;
  children?: React.ReactNode;
}

export function StickyFooterBar({
  variant,
  onBack,
  isBackDisabled = false,
  topContent,
  children,
}: StickyFooterBarProps) {
  const isLight = variant === 'light';

  return (
    <div
      className={`sticky bottom-0 z-20 flex w-full shrink-0 flex-col items-center px-8 pb-safe-offset-8 ${
        isLight ? 'bg-white pt-3' : 'pt-8'
      }`}
    >
      {/* Full-viewport gradient background for dark variant */}
      {!isLight && (
        <div className="pointer-events-none absolute inset-y-0 left-1/2 w-screen -translate-x-1/2 bg-gradient-to-t from-black/80 to-transparent" />
      )}

      <div className={`relative mx-auto flex w-full max-w-lg flex-col ${isLight ? 'gap-2' : 'gap-3'}`}>
        {/* Content above buttons (skip, error, deselect) */}
        {topContent}

        {/* Back + CTA row */}
        <div className={`flex w-full items-stretch ${isLight ? 'gap-2' : 'gap-3'}`}>
          {onBack && (
            <button
              onClick={onBack}
              disabled={isBackDisabled}
              className={`inline-flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full border transition-colors ${
                isLight
                  ? 'border-gray-200 bg-white text-gray-400 hover:border-gray-300 hover:text-gray-600 disabled:opacity-40'
                  : 'border-white/20 bg-white/10 text-white/60 hover:bg-white/20 disabled:opacity-40'
              }`}
              style={{
                cursor: isBackDisabled ? 'not-allowed' : 'pointer',
                pointerEvents: isBackDisabled ? 'none' : 'auto',
              }}
            >
              <BackArrow />
            </button>
          )}

          {/* CTA button area - fills remaining width */}
          <div className="flex min-w-0 flex-1 [&_button]:w-full [&_button]:rounded-full">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
